import { createApp } from "vue";
// import App from "./App.vue";
import App from "./App3Forms.vue";
// import VueCookies from 'vue3-cookies'

const app = createApp(App);
// app.use(VueCookies, {
//     expireTimes: "30d",
//     path: "/",
//     domain: "",
//     secure: true,
//     sameSite: "None"
// });

// app.mount("#app");
// app.mount("#app_blog_form");
app.mount("#forms3");
